__turbopack_context__.v({
  "chart": "_2X1ESG_chart",
  "container": "_2X1ESG_container",
  "heading": "_2X1ESG_heading",
  "infoIcon": "_2X1ESG_infoIcon",
  "popoverAnchor": "_2X1ESG_popoverAnchor",
  "subheading": "_2X1ESG_subheading",
  "tooltip": "_2X1ESG_tooltip",
  "tooltipName": "_2X1ESG_tooltipName",
  "tooltipText": "_2X1ESG_tooltipText",
  "tooltipValue": "_2X1ESG_tooltipValue",
  "xAxisLabel": "_2X1ESG_xAxisLabel",
  "yAxisLabel": "_2X1ESG_yAxisLabel",
});
